import React from "react";

import { Skeleton } from "@mui/material";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import { Theme } from "@mui/material/styles";
import { SxProps } from "@mui/system";

interface SkeletonGroupProps {
  lines: number;
  groupSx?: SxProps<Theme>;
}

export const SkeletonGroup = ({ groupSx, lines }: SkeletonGroupProps) => {
  return (
    <Stack direction={"column"} sx={groupSx}>
      {[...Array(lines).keys()].map((i) => (
        <Skeleton key={i} variant="text" />
      ))}
    </Stack>
  );
};
